import { PerfilHackathon } from './../../../models/user.model';
import { AuthService } from './../../../services/auth.service';
import { HelpersService } from './../../../services/helpers.service';
import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/models/user.model';

@Component({
  selector: 'app-mudar-perfil',
  templateUrl: './mudar-perfil.component.html',
  styleUrls: ['./mudar-perfil.component.css']
})
export class MudarPerfilComponent implements OnInit {

  showSpinner = true;

  constructor(private helper: HelpersService,
              private auth: AuthService) { }

  ngOnInit(): void {
    this.auth.getUser
    .then((user: User) => {
      const perfil: PerfilHackathon = user.perfis.find(p => p.hackathonId === this.helper.hackathonId);
      this.helper.mostrarPerfil(perfil.perfil);
      this.verificaSeComecouOEvento();
    });
  }

  private verificaSeComecouOEvento() {
    if (!this.helper.comparaDataHora(new Date(), this.helper.hackathonDataInicio)) {
      this.helper.openSnackBar('O hackathon já começou, você não pode mais trocar de perfil', '');
      this.helper.routeToDetalhes();
    } else {
      this.showSpinner = false;
    }
  }

  mudarPerfil(perfil: number) {
    this.helper.mostrarPerfil(perfil);
    this.auth.changePerfil(this.helper.hackathonId, perfil);
    this.helper.routeToDetalhes();
  }

}
